import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import About from './components/About';
import Stats from './components/Stats';
import Download from './components/Download';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  const [language, setLanguage] = useState('ar');

  useEffect(() => {
    // كشف إذا الصفحة انفتحت من Instagram أو Facebook
    const isInstagram = /Instagram|FBAN|FBAV/i.test(navigator.userAgent);
    const hasUTMParams = window.location.search.includes('utm_');
    
    // إذا من Instagram أو فيه UTM parameters، إلغاء الـ animations
    if (isInstagram || hasUTMParams) {
      // إظهار كل العناصر مباشرة بدون animation
      document.body.classList.add('no-aos');
    } else {
      AOS.init({
        duration: 600,
        once: true,
        offset: 20,
        easing: 'ease-in-out',
        disable: false,
        mirror: false,
        anchorPlacement: 'top-bottom'
      });
      
      setTimeout(() => {
        AOS.refresh();
      }, 100);
    }
  }, []);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
    document.documentElement.lang = language === 'ar' ? 'en' : 'ar';
    document.documentElement.dir = language === 'ar' ? 'ltr' : 'rtl';
  };

  return (
    <div className={`App ${language}`}>
      <Header language={language} toggleLanguage={toggleLanguage} />
      <Hero language={language} />
      <Features language={language} />
      <HowItWorks language={language} />
      <About language={language} />
      <Stats language={language} />
      <Download language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;
